/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cp_Cmp_3_TInputs */

const en_cp_cmp_3_t = /** @type {(inputs: Cp_Cmp_3_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Community, vendor credits, hackathons, guest speakers.`)
};

const id_cp_cmp_3_t = /** @type {(inputs: Cp_Cmp_3_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Komunitas, kredit vendor, hackathon, guest speaker.`)
};

/**
* | output |
* | --- |
* | "Community, vendor credits, hackathons, guest speakers." |
*
* @param {Cp_Cmp_3_TInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cp_cmp_3_t = /** @type {((inputs?: Cp_Cmp_3_TInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cp_Cmp_3_TInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cp_cmp_3_t(inputs)
	return en_cp_cmp_3_t(inputs)
});